import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const storageLanguage = localStorage.getItem("i18nextLng");

  const [selectedLanguage, setSelectedLanguage] = useState({
    name: t(`language.${storageLanguage}`),
    code: storageLanguage || i18n.language,
  });

  // Function to change the language
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng.code);
    localStorage.setItem("i18nextLng", lng.code);
    setSelectedLanguage(lng);
  };

  const languages = [
    { name: t("language.fr"), code: "fr" },
    { name: t("language.en"), code: "en" },
  ];

  return (
    <Dropdown
      variant="filled"
      value={selectedLanguage}
      onChange={(e) => changeLanguage(e.value)}
      options={languages}
      optionLabel="name"
      placeholder={t("language.placeholder")}
      className="title-3-variant select-language"
    />
  );
};

export default LanguageSelector;
